import { Dispatch } from '../architecture/frontend/index'
import {filter, withLatestFrom, map } from 'rxjs/operators'



import Table from '../Table/index'


const columnLayout= [
  // {
  //   field: 'checkbox',
  //   header: '',
  //   type: 'checkbox',
  //   width: '40px',
  //   fieldStyle: 'justify-center'
  //   },
    {
    field: 'id',
    header: 'Id',
    type: 'id',
    style: 'ph2',
    fieldStyle: 'ph2'
    },
    {
    field: 'shipmentId',
    header: 'Shipment',
    type: 'text',
    style: 'ph2',
    fieldStyle: 'ph2'
    },
      {
    field: 'ingredient.name',
    header: 'Ingredient',
    type: 'text',
    style: 'ph2',
    fieldStyle: 'ph2',
    },
      {
    field: 'customer.name',
    header: 'Customer',
    type: 'text',
    style: 'ph2',
    fieldStyle: 'ph2'
    },
]

Dispatch.getAction('shipment.select')
  .pipe(
    withLatestFrom(Dispatch.getState('modal.open')),
    filter(e => e[1]),
    map(e => e[0])
  )
  .subscribe(e => Dispatch.nextAction('__.Modal.close'))


const BaseEmailModal = (props) => {
  const key = props.modal?.details?.key
  const data = props.shipments?.rawData
  const loading = props.shipments?.loading ?? true
  const loadMore = false//!loading && props.shipments?.rawData?.length !== _.find(props.sidebar, sidebar => sidebar.view === 'claimTable')?.count

    return (
      <div key={key} className='pa4 w-100 avenir dark-gray' style={{maxHeight: '90vh'}}>
        <div className='flex justify-between'>
          <div></div>
          <div className='fw7 f3 pt2'>Select a Shipment</div>
          <div className='fw7 f5 moon-gray pointer'
            onClick={e => Dispatch.nextAction('__.Modal.close')}
            >X</div>
        </div>
        <div className='w-100 pt3 flex justify-center tc f5'>Select an existing shipment to create a claim from</div>
        <div className='pt3 mt4 flex justify-center'>
          {/* <div className='pt3 f6 fw9'>Search</div> */}
          <input 
              id='modalShipmentSearch'
              className={'mw5 w-100 pa2 ba b--moon-gray br2 bg-white fw4 tc'}
              style={{ outline: 'none', borderStyle: 'solid' }} 
              type="text" 
              placeholder='Search'
              onChange={e => Dispatch.nextAction('shipments.modal.search', e.target.value)}
            />
        </div>

        <div className='mt4'>
          <Table _tableName={'shipmentSelect'} _shipments={data} _loading={loading} _columnLayout={columnLayout} _loadMore={loadMore} _noOverflow={true} {...props}/>
        </div>

      </div>
    )
  }

export default BaseEmailModal